<template>
  <div>
    <flat-pickr
      :id="context.id"
      class="timeNoBackground w-100"
      :config="{
        enableTime: true,
        dateFormat: 'H:i',
        time_24hr: true,
        noCalendar: true,
        enableSeconds: false,
        onOpen: setCurrentTime
      }"
      v-model="time"
      :disabled="isDisabled"
      @input="onChange"
    />
  </div>
</template>

<script>
import { ref, onMounted, watch } from "@vue/composition-api";
import { BSpinner } from 'bootstrap-vue'
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    BSpinner,
    flatPickr
  },
  props: {
    id: String,
    name: String,
    label: String,
    fieldOptions: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    context: Object
  },
  setup(props, { emit }) {
    const time = ref('');
    const isDisabled = ref(false);

    onMounted(() => {
      isDisabled.value = props.context.attributes.disabled ?? false;
      if(props.context.model) {
        time.value = props.context.model
        return;
      }
      const now = new Date();
      const localTime = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
        .toISOString()
        .split('T')[1]
        .slice(0, 5);
      const showEmpty = props.fieldOptions.fieldTypeCfg.data[0]?.showEmpty

      setTimeout(() => {
        time.value = showEmpty ? '' : localTime
        onChange()
      }, 2000)    
    });

    watch(
      () => props.context.attributes.disabled,
      (newValue, oldValue) => {
        isDisabled.value = props.context.attributes.disabled ?? false;
      },
      { immediate: true }
    );

    watch(
      () => props.context.model,
      (newValue, oldValue) => {
        if(newValue) {
          setTime(newValue)
        }
      },
      { immediate: true }
    );

    async function onChange() {
      props.context.model = time.value
    }

    function setTime(value) {
      time.value = value
    }

    function setCurrentTime(selectedDates, dateStr, instance) {
      if (time.value) return;
      const now = new Date()
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      time.value = `${hours}:${minutes}`
      instance.setDate(time.value, true)
    }

    return {
      isDisabled,
      time,
      onChange,
      setCurrentTime
    }
  }
}
</script>
<style lang="scss" scoped>
.timeNoBackground {
  border-radius: 0.3em;
  background-color: transparent;
  margin: 0;
  border-radius: 0.3em;
  border: 1px solid #cecece;
  padding: 0.75em;
  margin: 0;
  background-color: #fff !important;
}
.dark-layout {
  .timeNoBackground {
    background-color: var(--second-dark) !important;
  }
}
</style>